import * as React from "react";

import { Race, Driver } from "../../api/model";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { getApi } from "../../api/ApiProvider";
import { ChangeEvent } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import BranchSelector, { BranchData } from "../BranchSelector";
import { getPingRemisionUrl } from "src/utils/utils";

import { IUser } from "src/utils/userHandler";

export interface RaceDataComponentProps {
  race: Race;
  user: IUser; // Assuming auth is optional, adjust as needed
}

export interface RaceActionState {
  open: boolean;
  cancelationMsg: string;
  driverSelected: number;
  driversList: Driver[];
  branchSelected: number;
  branchList: BranchData[];
  referenceId: number;
  branchId?: number;
}

class RaceMiscActions extends React.Component<
  RaceDataComponentProps,
  RaceActionState
> {
  constructor(props: any) {
    super(props);
    console.log(this.props.race, 'PROPS36');
    const drivers: Driver[] = [];
    const branches: BranchData[] = [];
    this.state = {
      open: false,
      cancelationMsg: "",
      driverSelected: 0,
      driversList: drivers,
      branchSelected: 0,
      branchList: branches,
      referenceId: this.props.race.referenceId,
    };

    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDriverChangeEvent = this.handleDriverChangeEvent.bind(this);
    this.doAssign = this.doAssign.bind(this);

    getApi()
      .driver()
      .listActiveByAdmin()
      .then((data: Driver[]) => {
        console.log(data, 'linea58');
        this.setState({ driversList: data },
          () => {
            this.setState({ driverSelected: this.state.driversList.findIndex((driver) => driver.id === this.props.race.driver.id) });
          }
        );
      });

    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data: BranchData[]) => {
        this.setState({ branchList: data });
      });
  }

  handleClickOpen = () => {
    this.setOpen(true);
  };

  setOpen(st: any) {
    this.setState({ open: st });
  }

  handleClose = () => {
    this.setOpen(false);
  };

  confirmCancelation = () => {
    this.setOpen(false);

    if (confirm) {
      getApi()
        .race()
        .cancel(this.props.race.id)
        .then(
          (ok) => {
            console.log("==>cancelado");
            this.setState({ cancelationMsg: "Cancelado" });
          },
          (err) => {
            this.setState({ cancelationMsg: "error" });
          }
        );
    }
  };

  doAssign = () => {
    const driverId = this.state.driversList[this.state.driverSelected].id;
    getApi()
      .race()
      .assign(this.props.race.id, driverId)
      .then(
        (race) => {
          this.setState({
            cancelationMsg:
              "Asignado a" + ((race.driver && race.driver.user.name) || ""),
          });
        },
        (err) => {
          this.setState({ cancelationMsg: "error al asignar" });
        }
      );
  };

  handleDriverChangeEvent(e: ChangeEvent<HTMLSelectElement>) {
    this.setState({
      driverSelected: +e.target.value,
    });
  }

  doChangeBranch = () => {
    console.log(this.state.branchSelected);
    const branchId = this.state.branchList[this.state.branchSelected].id;
    getApi()
      .race()
      .changeBranch(this.props.race.id, branchId)
      .then(
        (race) => {
          this.setState({
            cancelationMsg:
              "Sucursal Cambiada:" + ((race.branch && race.branch.name) || ""),
          });
        },
        (err) => {
          this.setState({ cancelationMsg: "Error al cambiar de sucursal" });
        }
      );
  };

  getPingLink = () => {
    return getPingRemisionUrl(this.state.referenceId);
  };

  render() {
    return (
      <div>
        <div>
          <h3>
            Acciones del pedido{" "}
            <a href={this.getPingLink()} target="_blank">
              {this.state.referenceId || ""}{" "}
            </a>
          </h3>
          {this.props.race.state !== 'DELIVERED' || this.props.user.permissions.includes('COMPANY_MANAGER') || this.props.user.permissions.includes('ROLE_ADMIN') ? (
            <>
              <div>Cancelación del pedido:</div>
              <Button
                variant="outlined"
                color="secondary"
                onClick={this.handleClickOpen}
              >
                Cancelar
              </Button>


              <hr />
              Asigna el viaje a un motorista:
              <hr />
              {this.renderAssing()}
              <Button variant="outlined" onClick={this.doAssign}>
                Asignar{" "}
              </Button>
              <hr />
              Cambio de sucursal:
              <hr />
              {
                this.state.branchList && this.state.branchList.length > 0 && this.renderBranchSelector(this.props.race.branch.id)
              }
              {/* {
            this.renderBranchSelector(this.props.race.branch.id)
          } */}
              <Button variant="outlined" onClick={this.doChangeBranch}>
                Cambiar{" "}
              </Button>
              <div>{this.state.cancelationMsg}</div>
            </>
          ) : (
            <div>
              <strong>El pedido ya fue entregado, no se puede cancelar</strong>
            </div>
          )}
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="cancela-pedido-dialog-title"
          aria-describedby="cancela-pedido-dialog-description"
        >
          <DialogTitle id="cancela-pedido-dialog-title">
            {"Desea cancelar el pedido ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="cancela-pedido-dialog-description">
              El pedido quedará en estado cancelado
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.confirmCancelation}
              color="secondary"
              autoFocus
            >
              Si, cancelar
            </Button>
            <Button onClick={this.handleClose} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderAssing() {
    return (
      <Select
        value={this.state.driverSelected}
        inputProps={{
          name: "assign-driver-selector",
          id: "driverAssingSelector",
        }}
        onChange={this.handleDriverChangeEvent}
      >
        {this.state.driversList
          ? this.state.driversList.map((driver, index) => (
            <MenuItem key={index} value={index}>
              {driver && driver.branch && driver.branch.name ? driver.branch.name : `Sin nombre de sucursal - id carrera:${driver.id}`} / {driver && driver.user && driver.user.name ? driver.user.name : 'Sin nombre de usuario'}{" "}
            </MenuItem>
          ))
          : ""}
      </Select>
    );
  }

  renderBranchSelector(idSucursal: number) {
    return (
      <BranchSelector
        value={idSucursal}
        branchList={this.state.branchList}
        onChange={(e) => {
          this.setState({ branchSelected: +e.target.value });
        }}
      />
    );
  }
}

export default RaceMiscActions;



// WEBPACK FOOTER //
// ./src/components/race/RaceMiscActions.tsx